

import React, { Component,useState, useCallback } from "react"
import MetaTags from 'react-meta-tags';
import './AddRessource.css';
import { format } from 'date-fns';
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardFooter,
  CardHeader,
  CardTitle,
  FormGroup,
  Label,
  Button,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Breadcrumb,
  BreadcrumbItem,
 
  

} from "reactstrap"
import Select from "react-select"
import axios from 'axios'
import  { Redirect } from 'react-router-dom'
// import $ from "jquery";

import Flatpickr from "react-flatpickr"
import { French } from "flatpickr/dist/l10n/fr.js";

import ReactSelect from 'react-select'
import {components} from 'react-select'
import makeAnimated from 'react-select/animated';
//import BootstrapSelect from "bootstrap-select"
import ModalMessage from "../pages/messages/ModalMessage"
import urlFile from "../../common/ApiFile"
import url from "../../common/api"
import {getLanguageList} from "../../services/langueService.js"
import {getThematiqueList} from "../../services/thematiqueService.js"
import {getFormatList} from "../../services/formatService.js"
import {getTypeRessourceList} from "../../services/typeRessourceService.js"
import {getTypeSystemeIrrigueList} from "../../services/systemeIrrigueService.js"
import {addMotCle,getMotCleList} from "../../services/motCleService.js"
import {getPaysList} from "../../services/paysService.js"
import {getQueries} from "../../queries/getQueries.js"
import {postQueries} from "../../queries/postQueries.js"
import {addAuteur,getAuteurList} from "../../services/auteurService.js"
import {postPjointeToLocalStorage,postImageToLocalStorage} from "../../services/fileService.js"

import CreatableSelect from 'react-select/creatable';
// import Select, { SelectInstance } from 'react-select';

// import { ColourOption, colourOptions } from '../data';
import { ActionMeta, OnChangeValue } from 'react-select';



const optionGroup = [
    {
      
      options: [
        { label: "PDF", value: "PDF" },
        { label: "MP4", value: "MP4" },
        { label: "JPEG", value: "JPEG" },
        { label: "MP3", value: "MP3" },
        { label: "EXCEL", value: "EXCEL" },
        
      ]
    },
    
  ]
  const optionLangue = [
    {
      
      options: [
        { label: "Francais", value: "Francais" },
        { label: "Anglais", value: "Anglais" },
        { label: "Wolof", value: "Wolof" }
      ]
    },
   
  ]

  const Menu = props => {
    const optionSelectedLength = props.getValue().length || 0;
    return (
      <components.Menu {...props}>
        {optionSelectedLength < 5 ? (
          props.children
        ) : (
          <div style={{ margin: 15 }}>Vous avez atteint le nombre maximum de mot-clés</div>
        )}
      </components.Menu>
    );
  };

class AddRessource extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedGroup: null,
            selectedLangue:"Langue",
            format:[],
            langue:[],
            unite:[],
            irrigue:[],
            profile:[],
            motcle:[],
            auteur:[],
            type_ressource:[],
            sous_type_ressource:[],
            thematique:[],
            idPrive:"prive",
            idThematique:"thematique",
            profile_id:[],

            profile_ids:[],

            motcle_ids:[],
            auteur_ids:[],
            thematique_ids:[],
            langue_ids:[],
            unite_ids:[],
            systeme_irrigue_ids:[],
            ok:"",
            counter:0,
            public_id:0,
            pj_ids:[],
            image_ids:[],
            localisation_ids:[],
            localisation:[],
            file_counter:0,
            langues_attributes:[],
            unites_attributes:[],
            systeme_attributes:[],
            profiles_attributes:[],
            pjointes_attributes:[],
            localisation_attributes:[],
            imgs_attributes:[],
            mots_attributes:[],
            auteurs_attributes:[],
            new_mots_attributes:[],
            new_auteurs_attributes:[],
            sous_type_ressource_attributes:[],
            thematiques_attributes:[],
            defaultDate:new Date(),
            date_edition:new Date(),
            dateDebut:"",
            //message:"Veuillez renseigner les champs obligatoires !",
            taille:0,
            fileok:true,
            dateFin:"",
            acces:[],
            show:false,
            success:true,
            video:"",
            message:"La ressource a été ajoutée avec succès !",
            titre:"Message ajout de ressource",
            boutton:"OK"

        }
        this.handleSelectGroup = this.handleSelectGroup.bind(this)

         this.onChangeFile.bind(this);

        this.removeDuplicates.bind(this);
        this.handleChangeLocalisation.bind(this);
        this.handleChangeLangue.bind(this);
        this.handleChangeUnite.bind(this);
        this.handleChangeSysteme.bind(this);
        this.handleChangeMotCle.bind(this);
        this.handleChangeThematique.bind(this);
        this.handleChangeProfile.bind(this);
        this.handleDateInterval.bind(this);
        this.handleChangeSousTypeRessource.bind(this);
        this.handleChangeAuteur.bind(this)

    }
    handleCreer=()=>{
      var date=new Date();
      const NewDate= format(date,'dd/MM/yyyy');
      const mot=_.uniqBy(this.state.mots_attributes, 'mot_cle_id')
      var profile =[...this.state.profiles_attributes,{"profile_id":this.state.public_id}]
     

      var data= {
        "nom": $("#nom").val(),
        "date_debut_publication": this.state.dateDebut,
        "date_fin_publication":this.state.dateFin,
        "date_edition":this.state.date_edition,
        //"statut": $("#statut option:selected").text(),
        "statut":"ACTIF",
        "video": $("#video").val(),
        //"image": "img",
        "description": $("#description").val(),
        "url": $("#url").val(),
        "utilisateur_id":JSON.parse(sessionStorage.getItem("authAshia")).id ,
        "le_format_id":$("#format_id option:selected").val(),
        "type_ressource_id":$("#type_ressource_id option:selected").val(),
        "ressource_profiles_attributes":profile,
        "ressource_mot_cles_attributes":mot,
        "ressource_thematiques_attributes":this.state.thematiques_attributes,
        "ressource_pjointes_attributes":this.state.pjointes_attributes,
        "ressource_imgs_attributes":this.state.imgs_attributes,
        "ressource_langues_attributes":this.state.langues_attributes,
        "ressource_unite_administratives_attributes":this.state.unites_attributes,
        "ressource_systeme_irrigues_attributes":this.state.systeme_attributes,
        "ressource_sous_ressources_attributes":this.state.sous_type_ressource_attributes,
        "ressource_pays_attributes":this.state.localisation_attributes,
        "ressource_auteurs_attributes":this.state.auteurs_attributes
        
      }
      console.log("donnee transmises:",data)
    
      
      postQueries("ressources",data).then(e=>{
       if(e){
        $("#initial").show()
        $("#chargement").hide()
        console.log("ressorce ok",e)
        if(this.state.new_mots_attributes.length){
          addMotCle(this.state.new_mots_attributes,e.id)
        }
  
        if(this.state.new_auteurs_attributes.length){
          addAuteur(this.state.new_auteurs_attributes,e.id)
        }
        

        this.setState({message:"La ressource a été ajoutée avec succès !"})
        this.setState({show:true,success:true});
       }else{
        $("#initial").show()
        $("#chargement").hide()
        this.setState({message:"Une Erreur est survenue lors de la sauvegarde. Veuillez Reéssayer plutard !"})
        this.setState({show:true,success:false});
       }

      })



    }
  

    handleSelectGroup = selectedGroup => {
        this.setState({ selectedGroup })
      }

      handleSelectGroup2 = selectedLangue => {
        this.setState({ selectedLangue })
      }

  
      removeDuplicates=(data)=>{
        let unique = {};
        data.forEach(function(i) {
          if(!unique[i]) {
            unique[i] = true;
          }
        });
        return Object.keys(unique);
      }

      componentDidMount() {
        sessionStorage.setItem("sis-session",900000)
        //Tooltips
        $(function () {
          $('[data-toggle="tooltip"]').tooltip()
        })

        // Compteur de lettre restantes dans description
        $('textarea').keyup(function() {    
          var characterCount = $(this).val().length,
              current_count = $('#current_count'),
              maximum_count = $('#maximum_count'),
              count = $('#count');    
              current_count.text(characterCount);        
        });


        $("#champ-unite-administrative").hide()
        $("#chargement").hide()
        $("#echecSauv").hide()
        $("#profile").hide()
        $("#valideFile").hide()
        var date = new Date(); 
        date.setFullYear(date.getFullYear() + 1);
    
        //date debut et fin par defaut
        this.setState({dateDebut:new Date()})

        this.setState({dateFin:date})

    getLanguageList().then(e=>this.setState({langue:e}))
    getPaysList().then(e=>this.setState({localisation:e}))
    getThematiqueList().then(e=>this.setState({thematique:e}))
    //getUniteAdministrativeList().then(e=>this.setState({unite:e}))
    getTypeRessourceList().then(e=>this.setState({type_ressource:e}))
    getMotCleList().then(e=>this.setState({motcle:e}))
    getFormatList().then(e=>this.setState({format:e}))
    getTypeSystemeIrrigueList().then(e=>this.setState({irrigue:e}))
    getAuteurList().then(e=>this.setState({auteur:e}))
    
    getQueries("profiles").then(e=>{
      const data=e
      try{
          this.setState({public_id:data.filter(x => (x.libelle).toLowerCase() === ("Public").toLowerCase())[0].id,
         
       })
        
       }catch(error){
  
       }

       data.filter(x => (x.libelle).toLowerCase() != ("Public").toLowerCase()).map((element,idx) =>{
        this.setState({profile:[...this.state.profile,{value:element.id,label:element.libelle}]})
      })

    })

      
    

      }


  handleRetour=()=>{
    this.setState({ok: <Redirect to='/accueil'  />});
  }
  handleAnnuler=()=>{
    this.setState({ok: <Redirect to='/liste-ressource'  />});
  }

  onChangeFile=(e)=>{
    var file=e.target.files
    console.log("LE FICHIER",file)
    try{
      this.setState({fileok:true})
      
      for(var i=0;i<file.length;i++){
        console.log("ff-file-size",file[i].size)
        if(parseInt(file[i].size)>16100612){
        //if(parseInt(file[i].size)>10000000){
          $("#pieceJointe").addClass("is-invalid")
          $("#valideFile").show()
          this.setState({fileok:false})
        }else{
          $("#pieceJointe").removeClass("is-invalid")
          $("#valideFile").hide()
          this.setState({fileok:true})
          // e.target.value = null
        }
      }
    }catch(error){console.log("ff-error",error)}
  }
 
  handleSendFile = ()=> {
    console.log("file-state",this.state.fileok)
    $("#initial").hide()
    $("#chargement").show()

    var imageList=document.getElementById("image").files
    var pjList=document.getElementById("pieceJointe").files


    this.setState({file_counter:parseInt(imageList.length)+parseInt(pjList.length)})

    if(imageList.length==0 && pjList.length==0){
     
      if($("#nom").val().length==0 || $("#description").val().length==0 || $("#type_ressource_id option:selected").val()==0 || $("#format_id option:selected").val()==0 ){
        this.setState({message:"Veuillez remplir les champs obligatoires !"})
        $("#initial").show()
        $("#chargement").hide()
        this.setState({show:true,success:false});
      }else{
        this.handleCreer()
      }
   
    }
    else{
      if($("#nom").val().length==0 || $("#description").val().length==0 ){
        this.setState({message:"Veuillez remplir les champs obligatoires !"})
        $("#initial").show()
        $("#chargement").hide()
        this.setState({show:true,success:false});
      }else{
       
        for(var i=0;i<pjList.length;i++){
          if(this.state.fileok){
            const formData = new FormData(); 
            console.log("file",formData) 
            // Update the formData object 
            formData.append( 
              "avatar", 
              pjList[i] 
            
            ); 
            const requestOptions = {
              method: 'POST',
              // mode: 'cors',
              // headers: {'Access-Control-Allow-Origin':'*' },
              body: formData
          };

          fetch(urlFile.file+"/fileupload.php", requestOptions)
          .then((response) => response.json())
          .then(response =>{console.log("ok,",response)
            this.sendPjointe({"file":response.name,"taille":response.size},url+"pjointes",1)
          },
            (error) => {
              if (error) {
                console.log("erreur save  file",error)
                $("#echecSauv").show()
                this.setState({message:"Une érreur est survenue lors du chargement du Fichier, veuillez réessayer !"})
                $("#initial").show()
                $("#chargement").hide()
                
                this.setState({show:true,success:false});
              }
            })
          }else{
            $("#echecSauv").show()
            this.setState({message:"Veuillez choisir des fichiers de tailles < 2Mo "})
            $("#initial").show()
            $("#chargement").hide()
            this.setState({show:true,success:false});
          }
        }; 
      
      // postImageToLocalStorage().then(el=>{
      //   console.log("putin de el",el)
      //   if(el){
      //     this.setState({imgs_attributes:el})
      //     if(pjList.length){
      //       postPjointeToLocalStorage().then(el=>{
      //         if(el){
      //           this.setState({pjointes_attributes:el})
        
      //             this.handleCreer()
                
              
      //         }
      //         else{
      //           $("#echecSauv").show()
      //           this.setState({message:"Echec Chargement du Fichier !"})
      //           console.log("Onee 1")
      //           $("#initial").show()
      //           $("#chargement").hide()
      //           this.setState({show:true,success:false});
      //         }
      //       })
      //     }
      //     else{
      //       this.handleCreer()
      //     }
      //   }
      //   else{
      //     $("#echecSauv").show()
      //     this.setState({message:"Echec Chargement du Fichier !"})
      //     console.log("Onee 2")
      //     $("#initial").show()
      //     $("#chargement").hide()
      //     this.setState({show:true,success:false});
      //   }
      // })


      //if(this.state.fileok){
   

      for(var i=0;i<imageList.length;i++){
        const formData = new FormData(); 
        
        // Update the formData object 
        formData.append( 
          "avatar", 
          imageList[i] 
        
        ); 
        const requestOptions = {
          method: 'POST',
          mode: 'cors',
          headers: {'Access-Control-Allow-Origin':'*' },
          body: formData
        };

        fetch(urlFile.file+"/fileupload.php", requestOptions)
        .then((response) => response.json()
        
        )
        .then(response =>{console.log("ok,",response)
        this.sendPjointe({"file":response.name,"taille":response.size},url+"images",0)

      },
      (error) => {
        console.log("Erroraaa 2",error)
        if (error) {
          console.log("Erroraaa 2",error)
          $("#echecSauv").show()
          this.setState({message:"Une érreur est survenue lors du chargement du Fichier, veuillez réessayer !"})
          $("#initial").show()
          $("#chargement").hide()
          this.setState({show:true,success:false});
        }
      } )
      };

  
    }
   }
  }



sendPjointe=(data,url,status)=>{
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json','Accept': 'application/json' },
      body: JSON.stringify(data)
  };
  fetch(url, requestOptions)
  .then((response) => response.json())
  .then(response =>{console.log("file send,",response)
  this.setState({file_counter:parseInt(this.state.file_counter)-1})
   if(status==0){

     this.setState({imgs_attributes:[...this.state.imgs_attributes,{"image_id":response.id}]})
   }
   else{
    this.setState({pjointes_attributes:[...this.state.pjointes_attributes,{"pjointe_id":response.id}]})
   }
   
   if(this.state.file_counter==0){
    
      this.handleCreer()
     
    
   }

 } )
      
   }

  handleChangeLocalisation = (e) => {
    $("#champ-unite-administrative").hide()
    var data=[]
    this.setState({localisation_attributes:data,unite:data})
    var localisation=[]
    var unite=[]
    try{


    e.map((element,idx) =>{
      
      
      element.unite_administratives.map((el)=>{
        unite=[...unite,{value:el.id,label:el.libelle}]
        this.setState({unite:unite})
      })
      localisation=[...localisation,{"pay_id":element.value}]

      this.setState({localisation_attributes:localisation})
      
    })
    
  } catch(e){
    this.setState({localisation_attributes:data,unite:data,unites_attributes:data})
  }
  }

  handleChangeLangue = (e) => {
    var data=[]
    this.setState({langues_attributes:data})
    try{
        e.map((element,idx) =>{
          this.setState({langues_attributes:[...this.state.langues_attributes,{"langue_id":element.value}]})
        })
      }catch(error){
        this.setState({langues_attributes:data})
      }   
  }
  handleChangeThematique = (e) => {
    var data=[]
    this.setState({thematiques_attributes:data})
    try{
      e.map((element,idx) =>{
        this.setState({thematiques_attributes:[...this.state.thematiques_attributes,{"thematique_id":element.value}]})
      })
    }catch(error){
      this.setState({thematiques_attributes:data})
    }
   
  }
  handleChangeUnite = (e) => {
    var data=[]
    this.setState({unites_attributes:data})
    try{
      e.map((element,idx) =>{
        this.setState({unites_attributes:[...this.state.unites_attributes,{"unite_administrative_id":element.value}]})
      })
    }catch(error){
      this.setState({unites_attributes:data})
    }
   
  }
  handleChangeSysteme = (e) => {
    var data=[]
    this.setState({systeme_attributes:data})
    try{
      e.map((element,idx) =>{
        this.setState({systeme_attributes:[...this.state.systeme_attributes,{"type_systeme_irrigue_id":element.value}]})
      })
    }catch(error){
      this.setState({systeme_attributes:data})
    }
    
  }

  handleChangeSousTypeRessource = (e) => {
    var data=[]
    this.setState({sous_type_ressource_attributes:data})
    try{
      e.map((element,idx) =>{
        this.setState({sous_type_ressource_attributes:[...this.state.sous_type_ressource_attributes,{"sous_type_ressource_id":element.value}]})
      })
    }catch(error){
      this.setState({sous_type_ressource_attributes:data})
    }
    
  }

  handleChangeAuteur = (e) => {
    var data=[]
    this.setState({auteurs_attributes:data,new_auteurs_attributes:data})

    try{
      e.map((element,idx) =>{
        //if(element.value.parseInt()==NaN)
        const auteur=this.state.auteur.find(val=>val.value==element.value)
        if(auteur){
          this.setState({auteurs_attributes:[...this.state.auteurs_attributes,{"auteur_id":element.value}]})
        }else{
          this.setState({new_auteurs_attributes:[...this.state.new_auteurs_attributes,{"nom":element.value}]})
        }
        
        })
    }catch(error){
      this.setState({auteurs_attributes:data,new_auteurs_attributes:data})
    }




   
    
  }
  handleChangeMotCle = (e) => {
    var data=[]
    this.setState({mots_attributes:data,new_mots_attributes:data})
    this.handleChangeNew
    try{
      e.map((element,idx) =>{
        //if(element.value.parseInt()==NaN)
        const mot=this.state.motcle.find(val=>val.value==element.value)
        if(mot){
          this.setState({mots_attributes:[...this.state.mots_attributes,{"mot_cle_id":element.value}]})
        }else{
          this.setState({new_mots_attributes:[...this.state.new_mots_attributes,{"libelle":element.value}]})
        }
        
        })
    }catch(error){
      this.setState({mots_attributes:data,new_mots_attributes:data})
    }
  }


  

  handleChangeAcces = () => {
    console.log("le select",$("#acces option:selected").val())
    if($("#acces option:selected").val()=="Privé"){
        $("#profile").show()
    }else{
      $("#profile").hide()
      
    }
  }

 handleChangeProfile = (e) => {
  var data=[]
  this.setState({profiles_attributes:data})
  console.log("===>>",e)
  try{
    e.map((element,idx) =>{
      this.setState({profiles_attributes:[...this.state.profiles_attributes.filter(x => x.profile_id != this.state.public_id),{"profile_id":element.value}]})
      console.log("===>>profile",element)
    })

  }catch(e){
    this.setState({profiles_attributes:data})
  }


}
 

handleDateInterval= (date)=> {

  // if(date.length==2){
  //   const NewDate1= format(date[0],'dd/MM/yyyy');
  //   const NewDate2= format(date[1],'dd/MM/yyyy');
    
  // console.log("date",date[0])
  //   this.setState({dateDebut:date[0]})

  //   this.setState({dateFin:date[1]})
  // }

  this.setState({date_edition:date[0]})


}


  handleErrorFormat=(e)=>{
    if(e.target.value!=0){
      $("#valideSate").hide()
      $("#format_id").removeClass("is-invalid")
      $("#echecSauv").hide()
    }else{
      $("#valideSate").show()
      $("#format_id").addClass("is-invalid")
    }
  }

  
  handleErrorResume=(e)=>{
    if(e.target.value.length>=30){
      $("#valideResume").hide()
      $("#description").removeClass("is-invalid")
      $("#echecSauv").hide()
    }else{
      $("#valideResume").show()
      $("#description").addClass("is-invalid")
    }
  }

  handleErrorTitre=(e)=>{
    if(e.target.value!=0){
      $("#valideTitre").hide()
      $("#nom").removeClass("is-invalid")
      $("#echecSauv").hide()
    }else{
      $("#valideTitre").show()
      $("#nom").addClass("is-invalid")
    }
  }

  handleErrorAuteur=(e)=>{
    if(e.target.value!=0){
      $("#valideAuteur").hide()
      $("#auteur").removeClass("is-invalid")
      $("#echecSauv").hide()
    }else{
      $("#valideAuteur").show()
      $("#auteur").addClass("is-invalid")
    }
  }

  handleErrorRessouce=(e)=>{
    var data=[]
    var type=[]
    this.setState({sous_type_ressource:[]})
    if(e.target.value!=0){
      setTimeout(()=>
      {
        this.state.type_ressource.find(val=>val.value==e.target.value)?.sous_types.map((el)=>{
          type=[...type,{value:el.id,label:el.libelle}]
          this.setState({sous_type_ressource:type})
        })
      }
    , 1)
 
    

      $("#valideRessource").hide()
      $("#type_ressource_id").removeClass("is-invalid")
      $("#echecSauv").hide()
    }else{
      this.setState({sous_type_ressource:data})
      $("#valideRessource").show()
      $("#type_ressource_id").addClass("is-invalid")
    }
  }

  handleValidate=()=>{
    if(this.state.success){
      this.setState({ok: <Redirect to='/liste-ressource'/>});
    }else{
      this.setState({show:false})
    }
    
  }

  handleCreate = inputValue => {
    console.log(inputValue);
    // this.setState({
    //   inputValue
    // });
  };

  handleFocus = () => {
    this.setState({
      menuIsOpen: true
    });
  };

  handleBlur = () => {
    this.setState({
      menuIsOpen: false
    });
  };
  
  getNewOptionData = inputValue => {
    this.setState({
      inputValue: [inputValue]
    });
  };



  handleChangeNew = function (newValue, actionMeta) {
    console.group('Value Changed');
    console.log(newValue);
    console.log("action: " + actionMeta.action);
    console.groupEnd();
  };

  // isValidNewOption = function (inputValue, selectValue) {
  //   inputValue.length > 0 && selectValue.length < 5;
  // };
    
    

  render() {
    const { pick } = this.state
    const { selectedGroup } = this.state
    const { selectedLangue } = this.state
    const animatedComponents = makeAnimated();
    const { options, menuIsOpen, inputValue } = this.state;

    var today = new Date();

    const isValidNewOption = (inputValue, selectValue) => inputValue.length > 0 && selectValue.length < 5;


  return (
          <React.Fragment>
            <div className="page-content"> {this.state.ok}

            <ModalMessage
              show={this.state.show}
              success={this.state.success}
              boutton={this.state.boutton}
              handleValidate={this.handleValidate}
              message={this.state.message}
              titre={this.state.titre}
              onCloseClick={() => this.setState({ show: false })}
              />


            <MetaTags>
                <title>Ajouter une ressource</title>
            </MetaTags>
            <Container fluid={true}>
                <Row className="mt-3">
                  <Col md="8">
                      <div className="page-title-box d-flex align-items-center justify-content-between">
                      <h4 className="mb-0 font-size-18">Nouvelle ressource</h4>
                      
                      </div>
                  </Col>
                </Row>
     
                <hr/>

                <Card style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                  {/* <CardHeader className="text-center" style={{borderTopRightRadius:"25px",borderTopLeftRadius:"25px",backgroundColor:"#6E7B74",color:"white"}}>
                    Descriptions de la ressource
                  </CardHeader> */}
                  <CardBody>
                  <h4 className="text-center mt-2">Description de la ressource</h4>
                  <hr/>
                  <Row className="mt-4"> 
                    <Col md="12">
                      <label>Titre de la ressource</label>
                      <Input
                        onChange={this.handleErrorTitre}
                        className="form-control is-invalid"
                        type="text"
                        id="nom"
                        placeholder="Titre de la ressource"
                      />
                      <div id="valideTitre" class="invalid-feedback">
                        Svp veuillez renseigner le titre de la ressource.
                      </div>
                    </Col>
                  </Row>
                  <Row className="mt-4"> 
                    <Col md="12">
                      <label>Auteur(s)</label>
                      {/* <Input
                        onChange={this.handleErrorAuteur}
                        className="form-control is-invalid"
                        type="text"
                        id="auteur"
                        placeholder="Auteur(s)"
                      />
                      <div id="valideAuteur" class="invalid-feedback">
                      Svp veuillez renseigner le/les Auteur(s).
                      </div> */}
                      <div
                        data-toggle="tooltip" 
                        data-placement="top" 
                        data-html="true"
                        title="Organisme de tutelle ou personne qui a écrit le document"
                      >
                      <CreatableSelect
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        isMulti
                        onChange={this.handleChangeAuteur}
                        options={this.state.auteur}
                        placeholder="Choisir ou ajouter le/les auteur(s)"
                      />
                      {/* <ReactSelect
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        isMulti
                        onChange={this.handleChangeAuteur}
                        options={this.state.auteur}
                        placeholder="Choisir ou ajouter le/les auteur(s)"
                      /> */}
                      </div>
                    </Col>
                    
                  </Row>
                  <Row className="mt-4"> 
                    <Col md="6">
                      <label>Format de la ressource</label> 
                      <select onChange={this.handleErrorFormat} className="form-select is-invalid" aria-label="Default select example" id="format_id">
                        <option value="0" selected>Choisir le format de la ressource</option>
                        {
                          this.state.format.map((element,idx) =>(
                            <option value={element.value}>{element.label}</option>
                          ))
                        }
                      </select>
                      <div id="valideState" class="invalid-feedback">
                        Svp veuillez Choisir le format de la ressource.
                      </div>
                    </Col>
                    <Col className="col-6">
                      <label>Dates d'édition de la ressource</label>
                      <div className="docs-datepicker" 
                        data-toggle="tooltip" 
                        data-placement="top" 
                        data-html="true"
                        title="Date d'édition de la ressource"
                      >
                        <InputGroup>
                          <Flatpickr
                            value={pick}
                            className="form-control d-block "
                            aria-label="Default select example"
                            placeholder="Choisissez la date d'édition de la ressource"
                            // id="datePub"
                            
                            options={{
                              locale:French,
                              // mode: "range",
                              maxDate:today,
                              altInput: true,
                              // enableTime: true,
                              // altFormat: "F j, Y",
                              altFormat: "d/M/Y"
                            }}
                             onChange={this.handleDateInterval}
                          />
                          <div className="input-group-append">
                            <button
                              type="button"
                              className="btn btn-outline-secondary docs-datepicker-trigger"
                              disabled
                            >
                              <i
                                className="fa fa-calendar"
                                aria-hidden="true"
                              />
                            </button>
                          </div>
                        </InputGroup>
                        <div className="docs-datepicker-container" />
                      </div>
                      {/* <div id="valideDate" class="invalid-feedback">
                        Svp veuillez Choisir les dates de début et de fin.
                      </div> */}
                    </Col>
                    {/* <Col className="col-6">
                      <label>Dates de début et de fin de publication</label>
                      <div className="docs-datepicker" 
                        data-toggle="tooltip" 
                        data-placement="top" 
                        data-html="true"
                        title="Début : Date à laquelle le document sera publiée et visible sur la plateforme |  Fin : Date à laquelle le document ne sera plus visible sur la plateforme"
                      >
                        <InputGroup>
                          <Flatpickr
                            value={pick}
                            className="form-control d-block "
                            aria-label="Default select example"
                            placeholder="Choisissez les dates de début et de fin de publication"
                            // id="datePub"
                            
                            options={{
                              locale:French,
                              mode: "range",
                              altInput: true,
                              enableTime: true,
                              // altFormat: "F j, Y",
                              altFormat: "d/M/Y"
                            }}
                            onChange={this.handleDateInterval}
                          />
                          <div className="input-group-append">
                            <button
                              type="button"
                              className="btn btn-outline-secondary docs-datepicker-trigger"
                              disabled
                            >
                              <i
                                className="fa fa-calendar"
                                aria-hidden="true"
                              />
                            </button>
                          </div>
                        </InputGroup>
                        <div className="docs-datepicker-container" />
                      </div>
                    </Col> */}
                    
                  </Row>

                  <Row className="mt-4"> 
                    <Col md="6">
                      <label>Type de ressource</label>
                      <select onChange={this.handleErrorRessouce} className="form-select is-invalid" aria-label="Default select example" id="type_ressource_id">
                        <option value="0" selected>Choisir le type de la ressource</option>
                        {
                          this.state.type_ressource.map((element,idx) =>(
                            <option value={element.value}>{element.label}</option>
                          ))
                        }
                      </select>
                      <div id="valideRessource" class="invalid-feedback">
                        Svp veuillez Choisir le type de la ressource.
                      </div>
                    </Col>
                    {
                    this.state.sous_type_ressource.length?
                    <Col md="6">
                      <label>Sous-type de ressource</label>
                      <ReactSelect
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        isMulti
                        onChange={this.handleChangeSousTypeRessource}
                        options={_.uniqBy(this.state.sous_type_ressource, 'label')}
                        placeholder="Choisir le/les sous-type de ressource(s)"
                      />
                    </Col>:null
                   }
                  </Row>
                  
                  <Row className="mt-4"> 
                    <Col md="12" > 
                      <div className="docs-datepicker" 
                        data-toggle="tooltip" 
                        data-placement="top" 
                        data-html="true"
                        title="Vous devez renseigner au minimum 100 charactères et 600 charactères au maximum"
                      >
                        <label>Résumé de la ressource</label>  
                        <textarea onChange={this.handleErrorResume} rows="6" className="form-control is-invalid" maxlength="600" autofocus id="description" placeholder="Résumé de la ressource" />
                        <div id="valideResume" class="invalid-feedback">
                          Svp veuillez renseigner le résumé de la ressource.
                        </div>
                      </div>
                    </Col>
                  </Row>
                  </CardBody>
                  {/* <CardFooter className="text-center" style={{borderBottomRightRadius:"25px",borderBottomLeftRadius:"25px",backgroundColor:"#032e87"}}>
                    
                  </CardFooter> */}
                </Card>

                <Card style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                  {/* <CardHeader className="text-center" style={{borderTopRightRadius:"25px",borderTopLeftRadius:"25px",backgroundColor:"#032e87"}}>
                    Catégorisations
                  </CardHeader> */}
                  <CardBody>
                  <h4 className="text-center mt-2">Catégorisation de la ressource</h4>
                  <hr/>
                  <Row className="mt-4"> 
                    <Col md="6">

                      <label>Pays(s)</label>
                      <div
                        data-toggle="tooltip" 
                        data-placement="top" 
                        data-html="true"
                        title="Choisir Autres si Région ou pays en dehors des six pays du Sahel listés et mieux préciser dans Unité administrative"
                      >
                        <ReactSelect
                          closeMenuOnSelect={false}
                          components={animatedComponents}
                          isMulti
                          onChange={this.handleChangeLocalisation}
                          options={this.state.localisation}
                          placeholder="Choisir la/les Pays(s)"
                        />
                      </div>
                    </Col>
                    {
                      this.state.unite.length?
                    <Col md="6" >
                      <label>Unité(s) administrative</label>
                      <div
                        data-toggle="tooltip" 
                        data-placement="top"
                        data-html="true"
                        title="Région particulière, ville ou division administrative du pays"
                      >
                        <ReactSelect
                          closeMenuOnSelect={false}
                          components={animatedComponents}
                          isMulti
                          onChange={this.handleChangeUnite}
                          options={_.uniqBy(this.state.unite, 'label')}
                          placeholder="Choisir l'unité administrative"
                        />
                      </div>
                    </Col>:null
                    }
                  </Row>


                  <Row className="mt-4">
                    <Col md="6">
                      <label>Langue(s)</label>
                      <ReactSelect
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        isMulti
                        onChange={this.handleChangeLangue}
                        options={this.state.langue}
                        placeholder="Choisir la/les langue(s)"
                      />
                    </Col>
                    <Col md="6">
                      <label>Type(s) de système(s) d'irrigation</label>
                      <ReactSelect
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        isMulti
                        onChange={this.handleChangeSysteme}
                        options={this.state.irrigue}
                        placeholder="Choisir le/les type(s) de système d'irrigation"
                      />
                    </Col>
                  </Row>


                  <Row className="mt-4"> 
                    <Col md="6">
                      <label>Thématique(s)</label>
                      <ReactSelect
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        isMulti
                        onChange={this.handleChangeThematique}
                        options={this.state.thematique}
                        placeholder="Choisir la/les thématique(s)"
                      />
                    </Col>  
                    <Col md="6">
                      <label>Mot(s) clé</label>
                      {/* <ReactSelect
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        isMulti
                        
                        onChange={this.handleChangeMotCle}
                        options={this.state.motcle}
                        placeholder="Choisir le/les mot(s) clé"
                      /> */}
                      <div
                        data-toggle="tooltip" 
                        data-placement="top" 
                        data-html="true"
                        title="Choisir un mot clé existant ou en ajouter un nouveau- Limité à 5 mots clés"
                      >
                        <CreatableSelect
                          closeMenuOnSelect={false}
                          components={{Menu}}
                          isMulti
                          onChange={this.handleChangeMotCle}
                          isValidNewOption={isValidNewOption}
                          options={this.state.motcle}
                          placeholder="Choisir le/les mot(s) clé"
                        />
                      </div>
                    </Col>
                  </Row>
                  </CardBody>
                </Card>

                <Card style={{borderRadius:"25px",borderColor:"#AAD29A",borderWidth:"5px"}}>
                  {/* <CardHeader className="text-center" style={{borderTopRightRadius:"25px",borderTopLeftRadius:"25px",backgroundColor:"#032e87"}}>
                    Médias
                  </CardHeader> */}
                  {/* <CardHeader className="text-center" style={{borderTopRightRadius:"25px",borderTopLeftRadius:"25px"}}>
                    <h3 className="text-center">Médias</h3>
                  </CardHeader> */}
                  
                  <CardBody>
                  <h4 className="text-center mt-2">Médias</h4>
                  <hr/>
                  <Row className="mt-4"> 
                    <Col md="12"> 
                      <label>Url</label>
                      <div className="input-group">
                        <Input
                          type="text"
                          className="form-control"
                          id="url"
                          placeholder="URL"
                        />
                        <div className="input-group-prepend  d-inline-block">
                          <span
                            className="input-group-text h-20"
                            id="validationTooltipUsernamePrepend"
                          >
                            <i className="bx bx-link"></i>
                          </span>
                        </div>
                      </div> 
                    </Col>
                  </Row>

                  <Row className="mt-4">
                    <Col md="4">
                      <label>Video</label>
                      <div className="input-group">
                        <Input
                          className="form-control"
                          type="text"
                          placeholder="Vidéo"
                          id="video"
                        />
                        <div className="input-group-prepend  d-inline-block">
                          <span
                            className="input-group-text h-20"
                            id="validationTooltipUsernamePrepend"
                          >
                            <i className="bx bx-link"></i>
                          </span>
                        </div>
                      </div>
                    </Col>

                    <Col md="4"> 

                      <label>Image(s)</label>

                       <Input
                            className="form-control"
                            type="file"
                            accept="image/*"
                            multiple 
                            placeholder="Image"
                            id="image"
                        />
                    </Col>

                    <Col md="4"> 

                      <label> Pièce(s) jointe(s)</label>

                      <Input
                        className="form-control"
                        type="file"
                        multiple 
                        placeholder="Pièce(s) jointe(s)"
                        id="pieceJointe"
                        onChange={this.onChangeFile}
                      />
                      <div id="valideFile" class="invalid-feedback">
                          {"Svp veuillez Choisir des fichiers de tailles < 16Mo."}
                      </div>
                    </Col>
                  </Row>  

                  </CardBody>
                </Card>

                <hr></hr>
                  <Row className="mt-4"> 
                    <Col md="6">
                      <label>Choisissez le type d'accès</label>
                      <select className="form-select" onChange={this.handleChangeAcces} aria-label="Default select example" id="acces">
                        {/* <option selected>Choisir le type d'accès</option> */}
                        <option selected value="Public">Public</option>
                        <option value="Privé">Privé</option>
                      </select>
                    </Col>  
                    <Col md="6" >
                      <div id="profile">
                      <label>Profil(s)</label>
                      <ReactSelect
                          closeMenuOnSelect={false}
                          components={animatedComponents}
                          isMulti
                          options={this.state.profile}
                          placeholder="Choisir le/les profil(s)"
                          onChange={this.handleChangeProfile} 
                          aria-label="Default select example" 
                          id="profile_id"
                        />
                    
                      </div>
                    </Col>
                  </Row>
                <hr></hr>


                <Row className="justify-content-start mt-5 mb-5">
                  {/* <Col md="3"></Col> */}
                  <Col md="6">
                    <Button 
                      id="initial" 
                      color="success" 
                      // className="b-lg" 
                      style={{backgroundColor:"#aad29a", borderColor:"#aad29a",float:"right",borderRadius:"10px"}}
                      onClick={this.handleSendFile}
                    >
                      Ajouter la ressource 
                    </Button>

                    <Button 
                      id="chargement" 
                      color="success" 
                      className="b-lg"
                      style={{backgroundColor:"#aad29a", borderColor:"#aad29a",borderRadius:"10px",float:"right"}}
                      type="button" disabled
                    >
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"> </span>
                      Ajout de la ressource...
                    </Button>
                  </Col>
                  <Col md="6">
                    <Button
                      // color="secondary" 
                      onClick={this.handleAnnuler} 
                      style={{backgroundColor:"#6A7172",float:"left",borderRadius:"10px"}} 
                      // className="b-lg"
                    >
                      Annuler
                    </Button>
                  </Col>
                </Row>

                <Row className="justify-content-start mt-3 ">
                  <Col md="3"></Col>
                  <Col md="6">
                  <div style={{textAlign:"center"}}>
                    <div id="echecSauv" className="alert alert-danger mt-2" role="alert">
                        {this.state.message}
                    </div>
                  </div>
                  </Col>
                  <Col md="3"></Col>
                </Row>        
               
                </Container>
                </div>
             
          </React.Fragment>
        )}

  }
  export default AddRessource